import { render } from "./TextMenuSet.vue?vue&type=template&id=d2573524&scoped=true"
import script from "./TextMenuSet.vue?vue&type=script&lang=js"
export * from "./TextMenuSet.vue?vue&type=script&lang=js"

import "./TextMenuSet.vue?vue&type=style&index=0&id=d2573524&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2573524"]])

export default __exports__